import PropTypes from 'prop-types';

import ImmutablePropTypes from 'react-immutable-proptypes';

import { Avatar } from 'flavours/glitch/components/avatar';

import ComposeFormContainer from '../containers/compose_form_container';

const InlineReplyCompose = ({ account }) => (
  <div className='inline-reply-compose'>
    {account && (
      <div className='inline-reply-compose__avatar'>
        <Avatar account={account} size={46} />
      </div>
    )}

    <div className='inline-reply-compose__bubble'>
      <ComposeFormContainer withoutNavigation singleColumn autoFocus />
    </div>
  </div>
);

InlineReplyCompose.propTypes = {
  account: ImmutablePropTypes.record,
};

export default InlineReplyCompose;
